import { useEffect, useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { router } from './routes.js'
import { configureAmplify, isAuthenticated, signIn } from './lib/auth.js'

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
})

export function App() {
  const [state, setState] = useState<'loading' | 'login' | 'ready'>('loading')

  useEffect(() => {
    async function init() {
      try {
        await configureAmplify()
        setState((await isAuthenticated()) ? 'ready' : 'login')
      } catch (err) {
        console.error('Failed to initialize auth', err)
        setState('login')
      }
    }
    void init()
  }, [])

  if (state === 'loading') {
    return <div className="app">Loading…</div>
  }

  if (state === 'login') {
    return (
      <div className="app" style={{ textAlign: 'center', paddingTop: '5rem' }}>
        <h1>cloudcat-apps admin</h1>
        <p className="muted">Sign in with your authorized Google account to continue.</p>
        <button onClick={() => signIn()}>Sign in with Google</button>
      </div>
    )
  }

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  )
}
